/**
 * Whether a table's pinned-left cell should be drawn.
 *
 * A pinned column may name a column id to follow. That column is expected to carry `hide`, so it
 * never draws in the table body — but it still sits in the stored preferences, which is what lets
 * the pinned cell be turned off in column customisation and its filter disappear along with it.
 *
 * `managedColumns` is the preference-filtered list, so a column the user has switched off is
 * absent from it. A pinned column with no id is always shown, which is how it behaved before
 * ids were introduced.
 */
export const shouldShowPinnedLeft = (pinnedLeft, managedColumns = []) => {
  if (!pinnedLeft) return false;
  if (!pinnedLeft.id) return true;
  return managedColumns.some((column) => column.id === pinnedLeft.id);
};
